export class LandingVideosSettingsEntity {
  homeYoutubeUrl: string | null

  storesYoutubeUrl: string | null

  publicMenuYoutubeUrl: string | null

  ownerOnboardingDesktopYoutubeUrl: string | null

  ownerOnboardingMobileYoutubeUrl: string | null

  constructor(value: Partial<LandingVideosSettingsEntity> = {}) {
    this.homeYoutubeUrl = value?.homeYoutubeUrl?.trim() || null

    this.storesYoutubeUrl = value?.storesYoutubeUrl?.trim() || null

    this.publicMenuYoutubeUrl = value?.publicMenuYoutubeUrl?.trim() || null

    this.ownerOnboardingDesktopYoutubeUrl = value?.ownerOnboardingDesktopYoutubeUrl?.trim() || null

    this.ownerOnboardingMobileYoutubeUrl = value?.ownerOnboardingMobileYoutubeUrl?.trim() || null
  }
}
